import React from 'react';
import InputField from '../Components/InputField';
import CheckboxField from '../Components/CheckboxField';
import TextAreaField from '../Components/TextareaField';
import SelectField from '../Components/SelectField';
import TelField from '../Components/TelField';
import 'react-phone-input-2/lib/style.css';

const controlType = {
  text: InputField,
  checkbox: CheckboxField,
  textarea: TextAreaField,
  select: SelectField,
  phone: TelField,
};

const renderField = (item, handleFieldChange, translations, country) => {
  const Component = controlType[item.type];
  const isPhoneComponent = item.type === 'phone';

  return (
    <Component
      key={item.name}
      onChange={handleFieldChange}
      ts={translations}
      {...item}
      {...(country && isPhoneComponent && { country })}
    />
  );
};

export default renderField;
